import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from '@ls/react-date-picker';
import { setSelectedAsOfDateStart, setSymbolicDateStart } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
import {
  selectSelectedAsOfDateStart,
  selectSymbolicDateStart,
} from 'state/selections/selectors';

const AsOfDatePickerStart = () => {
  const dispatch = useDispatch();
  const onChange = useCallback(
    (asOfDateStart) => dispatch(setSelectedAsOfDateStart(asOfDateStart)),
    [dispatch]
  );
  const selected = useSelector(
    selectSelectedAsOfDateStart(SelectionState.UNCOMMITTED)
  );
  const symbolicDateStart = useSelector(
    selectSymbolicDateStart(SelectionState.UNCOMMITTED)
  );
  const onChangeSymbolicDateStart = useCallback(
    value => dispatch(setSymbolicDateStart(value)),
    [dispatch]
  );

  return (
    <DatePicker
      onChange={onChange}
      selected={selected}
      onChangeSymbolicDate={onChangeSymbolicDateStart}
      symbolicDate={symbolicDateStart}
      variation={1}
      label="Start Date"
      enableQuickSelect
      quickSelectButtons= {['PMS12','PYS','PYE', 'CYS','PQS','PQE', 'CQS','PMS','PME','CMS', 'PBD', 'CBD']}
      showMonthDropdown
      showYearDropdown
    />
  );
};

export default AsOfDatePickerStart;
